import { render } from "./role.html?vue&type=template&id=c2f6f1c8&external"
import script from "./role.js?vue&type=script&lang=js&external"
export * from "./role.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__